import { alpha } from "@mui/system";

// Estilos específicos da paleta de equipamentos do diagrama
const styles = (theme) => ({
  // Painel da paleta de tipos de equipamento
  paletteBox: {
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    p: 1,
    borderRadius: 2,
    width: 260,
    backgroundColor: theme?.palette?.background?.paper,
    border: `1px solid ${theme?.palette?.divider}`,
  },
  // Cabeçalho compacto da paleta com ação de expansão
  paletteHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: 28,
    width: 245,
  },
  // Botão de expandir e recolher a paleta
  paletteToggleButton: {
    color: theme?.palette?.primary?.main,
    p: 0.25,
  },
  // Título do painel da paleta
  paletteTitle: {
    fontSize: 12,
    fontWeight: 700,
    color: theme?.palette?.text?.primary,
    mb: 0.5,
  },
  // Grid de botões de equipamentos com rolagem vertical
  paletteGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: 0.5,
    maxHeight: 300,
    overflowY: "auto",
    overflowX: "hidden",
    pr: 0.25,
  },
  // Campo de busca compacto para filtrar equipamentos na paleta
  paletteSearch: {
    "& .MuiInputBase-root": {
      fontSize: 12,
    },
    "& .MuiInputBase-input": {
      py: 0.5,
      px: 1,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme?.palette?.divider,
    },
  },
  // Card individual de tipo de equipamento clicável
  paletteButton: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 0.25,
    width: 72,
    p: 0.75,
    borderRadius: 1.5,
    border: `1px solid ${theme?.palette?.divider}`,
    backgroundColor: theme?.palette?.background?.default,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: alpha(theme?.palette?.primary?.main || "#000", 0.12),
    },
  },
  // Estado desabilitado do card quando em modo de visualização
  paletteButtonDisabled: {
    opacity: 0.45,
    cursor: "not-allowed",
    "&:hover": {
      backgroundColor: theme?.palette?.background?.default,
    },
  },
  // Ícone exibido no centro do card do equipamento
  paletteButtonIcon: {
    fontSize: 22,
    color: theme?.palette?.primary?.main,
  },
  // Label com nome do equipamento abaixo do ícone
  paletteButtonLabel: {
    fontSize: 10,
    fontWeight: 600,
    lineHeight: 1.1,
    textAlign: "center",
    color: theme?.palette?.text?.primary,
  },
  // Texto explicativo auxiliar
  paletteHint: {
    fontSize: 11,
    color: theme?.palette?.text?.secondary,
    mt: 0.5,
  },
  // Contêiner para posicionar o botão de ações sobre o card
  paletteItemWrapper: {
    position: "relative",
  },
  // Botão de menu de ações sobreposto no card customizado
  paletteItemMenuButton: {
    position: "absolute",
    top: 2,
    right: 2,
    p: 0.25,
    backgroundColor: theme?.palette?.background?.paper,
    border: `1px solid ${theme?.palette?.divider}`,
    "&:hover": {
      backgroundColor: theme?.palette?.background?.paper,
    },
  },
  // Avatar com imagem do ícone customizado
  paletteButtonAvatar: {
    width: 22,
    height: 22,
    "& .MuiAvatar-img": {
      objectFit: "cover",
    },
  },
  // Card de adicionar equipamento personalizado com borda tracejada
  paletteButtonAdd: {
    borderStyle: "dashed",
  },
});

export default styles;
